import React from 'react'
import { Box } from '@mui/material'
import CloseButton from 'src/components/common/CloseButton'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'

const PremiumBreakUp = ({ setViewOtherDetails }) => {
  const classes = useStyles()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const selectedQuote = motorDetails?.selectedQuote

  return (
    <Box className={classes.PriceDetailsOutlinePopUp}>
      <Box className={classes.closeButton}>
        <CloseButton
          id='closeButton'
          title='Close'
          handleClose={() => setViewOtherDetails(false)}
          classname={classes.clsBtn}
        />
      </Box>
      <Box className={classes.PriceDetailsContainerRow}>
        <Box className={classes.PriceDetailsContainerColumn}>
          <Box>
            <img src={selectedQuote?.providerImage} alt='Provider Image' />
          </Box>
          <Box className={classes.brandTagLine}>
            {selectedQuote?.providerName}
          </Box>
        </Box>
        <Box className={classes.PriceDetailsContainerColumn}>
          <Box className={classes.coverText}>
            Cover: {formatToINR(selectedQuote?.idvCover)}
          </Box>
        </Box>
      </Box>
      <Box className={classes.PriceElementsContainer}>
        {selectedQuote?.ownDamagePremium ? (
          <Box className={classes.PriceDetailsContainerRow}>
            <Box className={classes.PriceDetailsContainerRowHeadingStyleBold}>
              Own Damage Premium
            </Box>
            <Box className={classes.PriceDetailsContainerRowDataStyleBold}>
              {formatToINR(selectedQuote?.ownDamagePremium)}
            </Box>
          </Box>
        ) : null}
        {selectedQuote?.thirdPartyPremium ? (
          <Box className={classes.PriceDetailsContainerRow}>
            <Box className={classes.PriceDetailsContainerRowHeadingStyleBold}>
              Third Party Premium
            </Box>
            <Box className={classes.PriceDetailsContainerRowDataStyleBold}>
              {formatToINR(selectedQuote?.thirdPartyPremium)}
            </Box>
          </Box>
        ) : null}
        <Box className={classes.PriceDetailsContainerRow}>
          <Box className={classes.PriceDetailsContainerRowHeadingStyle}>
            GST@18%
          </Box>
          <Box className={classes.PriceDetailsContainerRowDataStyleAddOns}>
            <Box className={classes.PriceDetailsContainerRowDataStyle}>
              + {formatToINR(selectedQuote?.gst)}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.paCoverOuterDiv}>
        <Box className={classes.paCoverInnerDiv}>
          <Box>
            {selectedQuote?.premiumBreak?.map((premiuimBreak) => {
              return (
                <Box
                  className={classes.premiuimBreakContainer}
                  key={premiuimBreak?.groupName}
                >
                  <Box className={classes.groupName}>
                    {premiuimBreak?.groupName}
                  </Box>
                  <Box className={classes.groupNameValue}>
                    {premiuimBreak?.itemList?.map((item) => {
                      return (
                        <>
                          <Box className={classes.groupItems}>
                            <Box>{item?.label}</Box>
                            <Box>{item?.premium}</Box>
                          </Box>
                        </>
                      )
                    })}
                  </Box>
                </Box>
              )
            })}
          </Box>
        </Box>
      </Box>
      <Box className={classes.PriceDetailsTotalOutline}>
        <Box className={classes.PriceDetailsTotalOutlineMain}>
          <Box className={classes.PriceDetailsContainerRow}>
            <Box className={classes.textBold}>Total Premium</Box>
            <Box className={classes.textBold}>
              {formatToINR(selectedQuote?.grossTotalPremium)}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PremiumBreakUp

const useStyles = makeStyles({
  PriceDetailsOutlinePopUp: {
    padding: 20,
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    backgroundColor: 'white',
    borderRadius: '10px',
  },
  closeButton: {
    width: '100%',
    textAlign: 'right',
  },
  PriceDetailsContainerRowDataStyleBold: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '1.1875em',
    letterSpacing: '0em',
    color: '#000000',
  },
  PriceDetailsContainerColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  paCoverText: { color: '#64434E', fontSize: '12px' },
  PriceElementsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  PriceDetailsContainerRowHeadingStyleBold: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '1em',
    letterSpacing: '0em',
    color: '#000000',
  },
  PriceDetailsContainerRowHeadingStyle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1em',
    letterSpacing: '0em',
    color: '#000000',
  },
  PriceDetailsContainerRowDataStyleAddOns: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'right',
  },
  paCoverOuterDiv: {
    border: '1px',
    borderRadius: '0.6em',
    backgroundColor: '#F4DEE5',
  },
  paCoverInnerDiv: {
    padding: 10,
  },
  premiuimBreakContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '10px',
    borderBottom: '1px solid #CCCCCC',
    margin: '5px',
    '&:last-child': {
      borderBottom: '0px',
    },
  },
  groupNameValue: {
    color: '#64434E',
    fontSize: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  groupName: {
    paddingBottom: '5px',
  },
  groupItems: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: '2px',
  },
  PriceDetailsTotalOutline: {
    border: '1px solid #EF669B',
    borderRadius: '0.6em',
    padding: '5px',
    background: '#FFFFFF',
  },
  textBold: {
    fontWeight: 'bold',
  },
  PriceDetailsContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '6px',
  },
})
